import './App.css';
import { Outlet, useNavigate } from 'react-router-dom';
// import Header from './components/Header';
// import Footer from './components/Footer';
import { Toaster } from "react-hot-toast";
import { useEffect } from 'react';
import ScrollToTop from './helpers/ScrollToTop';
import useFetchLoginUser from './hooks/useFetchLoginUser';
import { setNavigationHandler } from './common/apiClient';
import PageLoader from './helpers/PageLoader';

function App() {
  const navigate = useNavigate();
  // const location = useLocation();
  const loading = useFetchLoginUser();
  // const isAdminPanel = location.pathname.startsWith('/admin-panel');

  // Set up navigation handler for API client
  useEffect(() => {
    setNavigationHandler(navigate);
  }, [navigate]);

  if (loading) {
    return (
      <div className="h-screen flex justify-center items-center">
        <PageLoader />
      </div>
    );
  }
  return (
    <>
      <ScrollToTop />

      {/* {!isAdminPanel && <Header />} */}

      <main className='bg-[#f5f7f5]'>
        <Outlet />
      </main>

      {/* {!isAdminPanel && <Footer />} */}

      {/* Toast Notifications */}
     <Toaster position="top-center" toastOptions={{ duration: 3000 }} />

    </>
  );
}

export default App;
